import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'
Vue.use(VueRouter)

export default function ({ store }) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  })

  // Re-propaga o marcador de webview do Main Hub: as navegações internas
  // reconstroem a query string (ex.: { cliente, tenant }) e descartariam o
  // digital_main_hub_embedded, perdendo a customização de layout embutido.
  Router.beforeEach((to, from, next) => {
    if (to.query.digital_main_hub_embedded === 'true') {
      sessionStorage.setItem('digital_main_hub_embedded', 'true')
      return next()
    }
    if (sessionStorage.getItem('digital_main_hub_embedded') === 'true') {
      return next({
        path: to.path,
        hash: to.hash,
        params: to.params,
        query: { ...to.query, digital_main_hub_embedded: 'true' },
        replace: true,
      })
    }
    next()
  })

  Router.beforeEach((to, from, next) => {
    store.commit('auth/initialiseStore', {}); //Force always update

    const token = store.getters['auth/token']

    const { authorize, requiresAuth } = to.meta;

    if (authorize || requiresAuth) {
      if (!token || (authorize && !store.getters['auth/hasAuthority'](authorize))) {
        next({
          path: '/',
          params: {
            nextUrl: to.fullPath
          }
        })
      }

    }

    next()
  })

  return Router
}
